<template>
    <div class="container">
        <div class="comment_form">
            <h6>Deja un Comentario</h6>
            <form @submit.prevent="onSendComment">
                <div class="form-group">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Nombre"
                        v-model.trim="$v.nombre.$model"
                        :class="{ 'is-invalid':$v.nombre.$error }"
                    />
                    <div class="invalid-feedback">
                        <span v-if="!$v.nombre.$required">Este campo es requerido</span>
                    </div>
                </div>
                <div class="form-group">
                    <input
                        type="email"
                        class="form-control"
                        placeholder="Correo electrónico"
                        v-model.trim="$v.email.$model"
                        :class="{ 'is-invalid':$v.email.$error }"
                    />
                    <div class="invalid-feedback">
                        <span v-if="!$v.email.$required">Este campo es requerido</span>
                        <br>
                        <span v-if="!$v.email.$email">Formato de correo electrónico inválido</span>
                    </div>
                </div>
                <div class="form-group">
                    <textarea
                        rows="5"
                        class="form-control"
                        placeholder="Comentario"
                        v-model="comentario"
                        v-model.trim="$v.comentario.$model"
                        :class="{ 'is-invalid':$v.comentario.$error }"
                    ></textarea>
                    <div class="invalid-feedback">
                        <span v-if="!$v.comentario.$required">Este campo es requerido</span>
                    </div>
                </div>
                <div class="form-group">
                    <button 
                    :disabled="onLoadForm"
                    @click="onSendComment"
                    type="submit" 
                    class="btn">
                        <clip-loader
                        :class="{ 'd-none': !onLoadForm }"
                        style="display: inline;margin-right: 10px;"  
                        color="#fff" 
                        size="15px"></clip-loader>
                        Enviar Comentario
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import {required, email} from 'vuelidate/lib/validators';
import {ADD_COMENTARIO} from "store/store-constants";
export default {
    data() {
        return {
            onLoadForm: false
        }
    },
    props: {
        id: String
    },
    validations: {
        nombre: {
            required
        },
        email: {
            required,
            email
        },
        comentario: {
            required
        }
    },
    computed: {
        ...mapFields("fichaTecnica", [
            "comentario.nombre",
            "comentario.email",
            "comentario.comentario",
        ]),

        comentarioData() {
            return this.$store.state.fichaTecnica.comentario;
        }
    },
    methods: {

        onSendComment() {
            this.$v.$touch()
            if(this.$v.$invalid){
                return this.submitStatus = "False";
            }else{
                this.onLoadForm = true;
                var data = {
                    ...this.comentarioData,
                    id_reporte: this.id
                }
                axios.post('/ajax/send_comment', data).then((response) =>{
                    var parseRes = response.data;
                    console.log(">>>>", parseRes);
                    this.$store.commit(ADD_COMENTARIO, parseRes.comment);
                    this.onLoadForm = false;
                });
            }
         }
    },
};
</script>

<style lang="scss" scoped></style>
